import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import { pathToPage } from '@/routes'
import { useAppNavigate } from './useAppNavigate'

const PARENT_PAGE_MAP: Record<string, string> = {
  'user-management': 'submenu-admin',
  'municipality-management': 'submenu-admin',
  'log-operation-history': 'submenu-admin',
  'release-history': 'submenu-admin',
  'ocr-success-stats': 'submenu-admin',
  'announcement-management': 'submenu-admin',
  'data-import': 'ocr-read-list',
  'ocr-read-import': 'ocr-read-list',
  'import-error-edit': 'ocr-read-list',
  'ocr-read-list': 'home',
  'recipient-search': 'home',
  'payment-job': 'home',
  'csv-export': 'submenu-report',
  'bank-transfer': 'submenu-report',
  'notification-output': 'submenu-report',
  'business-report': 'submenu-report',
}

export function useBackToParent(): () => void {
  const navigate = useAppNavigate()
  const location = useLocation()
  const currentPage = pathToPage(location.pathname)
  const parentPage = PARENT_PAGE_MAP[currentPage] || 'home'

  return useCallback(() => {
    navigate(parentPage)
  }, [navigate, parentPage])
}
